import { Route, Routes } from "react-router-dom";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { MantineProvider } from "@mantine/core";
import { useAuth0 } from "@auth0/auth0-react";
import { NotificationsProvider } from "@mantine/notifications";

import WelcomeScreen from "WelcomeScreen";
import AppRoutes from "routes";
import Animation from "routes/Animation/Animation";
import LandingPage from "routes/LandingPage";
import TokenSetup from "components/TokenSetup";
import SurveyResults from "components/SurveyResults";
import SurveyList from "components/SurveyList";

import { queryClient } from "App";

const LoginGateway = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  const isCypress = process.env.REACT_APP_IS_CYPRESS;

  const isPermissionGranted = isCypress
    ? !!localStorage.getItem("token")
    : isAuthenticated && !isLoading;

  return (
    <MantineProvider
      theme={{
        colorScheme: "dark",
        colors: {
          // override dark colors here to change them for all components
          dark: [
            "#ffffffa3",
            "#acaebf",
            "#8c8fa3",
            "#666980",
            "#4d4f66",
            "#34354a",
            "#2b2c3d",
            "#121212",
            "#0c0d21",
            "#01010a",
          ],
        },
      }}
      withGlobalStyles
    >
      <NotificationsProvider>
        {isPermissionGranted ? (
          <TokenSetup>
            <QueryClientProvider client={queryClient}>
              <AppRoutes />
              <ReactQueryDevtools />
            </QueryClientProvider>
          </TokenSetup>
        ) : (
          <>
            <QueryClientProvider client={queryClient}>
              <Routes>
                <Route path="/public" element={<SurveyList />} />
                <Route path="/" element={<WelcomeScreen />} />
                <Route path="survey/:surveyId" element={<SurveyResults />} />
                <Route
                  path="/intro/member"
                  element={<Animation animationType="member" />}
                />
                <Route
                  path="/intro/leader"
                  element={<Animation animationType="leader" />}
                />
                <Route path="/landing" element={<LandingPage />} />
                <Route path="*" element={<WelcomeScreen />} />
              </Routes>
            </QueryClientProvider>
          </>
        )}
      </NotificationsProvider>
    </MantineProvider>
  );
};

export default LoginGateway;
